import script from "./Biography.vue?vue&type=script&setup=true&lang=js"
export * from "./Biography.vue?vue&type=script&setup=true&lang=js"

import "./Biography.vue?vue&type=style&index=0&id=7564c734&lang=scss"

const __exports__ = script;

export default __exports__